export default __webpack_public_path__ + "static/media/1227.aee33b30.png";